import React from "react";
import { Redirect } from "react-router-dom";
import { useCashbookStatus } from "../../../helpers/cashbookStatus";
import { canUseRounds, isKarkhanaSupervisor } from "../../../helpers/karkhanaEnabled";
import { kp } from "../karkhanaPaths";
import "./cashbook.scss";

export const readRole = (): string | undefined => {
  try {
    return JSON.parse(localStorage.getItem("authUser") || "null")?.users?.role;
  } catch {
    return undefined;
  }
};

export const CashSkeleton = () => (
  <div className="cb" role="status" aria-label="Loading">
    <div className="cb-skeleton is-big" />
    <div className="cb-skeleton" />
    <div className="cb-skeleton" />
  </div>
);

type Props = { children: React.ReactNode; staffOnly?: boolean; supervisorOnly?: boolean };

/**
 * Every cash book v1 page sits inside this: without Karkhana → Karkhana home; while the status loads →
 * a skeleton; CASHBOOK off → the cash book address (today's page); a page for the other side → the
 * cash book address too. The server refuses the calls anyway; this keeps people off dead screens.
 */
const CashbookGuard = ({ children, staffOnly, supervisorOnly }: Props) => {
  const role = readRole();
  const { enabled, loaded } = useCashbookStatus();
  if (!canUseRounds(role)) return <Redirect to={kp.home()} />;
  if (!loaded) return <CashSkeleton />;
  const supervisor = isKarkhanaSupervisor(role);
  if (!enabled || (staffOnly && supervisor) || (supervisorOnly && !supervisor)) return <Redirect to={kp.cashBook()} />;
  return <>{children}</>;
};

export default CashbookGuard;
